<script setup>

import {watch, ref, computed, reactive, onMounted} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import {ArrowLeftIcon, UserCircleIcon, FireIcon, SparklesIcon, TrashIcon, CheckIcon, XMarkIcon} from '@heroicons/vue/24/solid'

import Header from './Header.vue'
import Message from './Message.vue'
import UserName from './UserName.vue'
import Avatar from './Avatar.vue'
import UserTag from './UserTag.vue'
import ButtonLoad from './ButtonLoad.vue'
import Report from './Report.vue'

const app_server = import.meta.env.VITE_APP_SERVER;
const router = useRouter();
const route = useRoute();

import {useMessageStore } from '@/stores/messagestore.js'
const messageStore = useMessageStore();

import {useUserStore } from '@/stores/userstore.js'
const userStore = useUserStore();

const actions = [
    "chat", "match", "login",
];

const durations = [
    ["1h", 3600],
    ["1d", 3600*24],
    ["3d", 3600*24*3],
    ["1w", 3600*24*7],
    ["1m", 3600*24*31],
    ["1y", 3600*24*365],
    ["1c", 3600*24*365*100],
];

const duration_lookup = Object.fromEntries(durations.map( ([a,b]) => [b,a]));
console.log(duration_lookup);

const extra_data = reactive({
    report: null,
    extra_data: null,
    reports: [],
    user: null,
    user_submitted: null,
    match_data: null,
    dice_ok: null,
    open_modal: false,
});

const timeout_data = reactive({
    reason: "",
    duration: 0,
    obj: null,
    user_id: "",
});

function go_to_report(report){ // COPIED from ModerateReports.vue
    if(report.object_type == "user"){
        router.push({name: 'mod-report-user', params: {report_id: report.report_id}});
    }else if(report.object_type == "match"){
        router.push();
    }else if(report.object_type == "match"){
        router.push();
    }
}

watch( () => route.params.report_id, (newID, oldID) =>{
    get_report();
});


async function get_report(){
    const report_id = route.params.report_id;

    const response = await fetch(app_server + `/report/${report_id}/`, {
        method: "GET",
        mode: "cors",
        headers:{
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("jwt"),
        },
    });
    
    const data = await response.json();

    console.log(data);

    extra_data.report = data.report;
    extra_data.extra_data = data.extra_data;
    extra_data.blog = data.extra_data.object;
    extra_data.author = data.extra_data.author;
    extra_data.reports = data.reports;

    get_user_info(extra_data.report.submitter_id).then(
        (x) => extra_data.user_submitted = x
    );
}

async function get_user_info(user_id=null){
    if(user_id == null){
        user_id = extra_data.user_id;
    }

    const response = await fetch(app_server + `/user/${user_id}/info/`, {
        method: "GET",
        mode: "cors",
        headers:{
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("jwt"),
        },
    });
    
    const data = await response.json();
    
    const user = data.user; 
    user.date_joined = new Date(user.date_joined);

    console.log(data);

    return user
}

async function change_report_status(new_status){
    const response = await fetch(app_server + `/report/${extra_data.report.report_id}/changestatus/`, {
        method: "POST",
        mode: "cors",
        headers:{
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("jwt"),
        },
        body: JSON.stringify({'status': new_status}),
    });
    
    const data = await response.json();
    console.log("Changed status", data);
    get_report();
    messageStore.alertUser("Changed Status", "Succesfully changed the status to: "+new_status);
}

async function delete_post(){
    if(!confirm("Are you sure you want to delet the blog post?")){
        return;
    }
    const response = await fetch(app_server + `/report/${extra_data.report.report_id}/deleteblog/`, {
        method: "POST",
        mode: "cors",
        headers:{
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("jwt"),
        },
        body: JSON.stringify({}),
    });
    
    const data = await response.json();
    get_report();

    if(data.status == "success"){
        messageStore.alertUser("Blog post deleted", "Succesfully deleted the blog post");
    }
}

async function set_flag(flag){
    const response = await fetch(app_server + `/report/${extra_data.report.report_id}/setflagblog/`, {
        method: "POST",
        mode: "cors",
        headers:{
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("jwt"),
        },
        body: JSON.stringify({
            flag: flag
        }),
    });
    
    const data = await response.json();
    get_report();
    if(data.status == "success"){
        messageStore.alertUser("Set flag", "Set the flag to " + flag);
    }
}

function get_time(seconds){
    /*
    * returns a human reabable time string (bit overcomplicated, but wanted it to
    * be nicely formatted.
    */
    const months = Math.floor(seconds / (30*24*60*60)).toString();
    const days = Math.floor((seconds % (30*24*60*60)) / (24*60*60)).toString();
    const hours = Math.floor((seconds % (24*60*60)) / (60*60)).toString();
    const minutes = Math.floor((seconds % (60*60)) / 60).toString();
    const sec = Math.floor(seconds % 60).toString();

    var time = 0;
    var unit = ""

    if(months > 0){
        time = months;
        unit = `months`;
    }else if(days > 0){
        time = days;
        unit = `days`;
    }else if(hours > 0){
        time = hours;
        unit = `hours`;
    }else if(seconds >= 60){
        time = minutes;
        unit = `minutes`
    }else{
        time = sec; 
        unit = "seconds";
    }

    if(time == 1){
        unit = unit.slice(0, -1);
    }
    
    return `${time} ${unit}`;
}

onMounted(async () => {
    await Promise.allSettled([
        userStore.loadUser(),
        get_report(),
    ])
});

function handleMove(){

}

</script>
<template>
    <Header/>
    <div class="container mx-auto max-w-[70svh] flex flex-col gap-y-8 mb-32 px-2">
        <h1 class="flex gap-x-4 items-center text-4xl mt-8 mb-4 font-semibold">
            <a @click="router.go(-1)" class="hover:text-accent-3-color cursor-pointer">
                <ArrowLeftIcon class="size-8" />
            </a>
            Blog Report
        </h1>
        <div v-if="extra_data.report != null">
            <h2 class="text-2xl">Report</h2>
            <h3 class="text-xl">Status: {{ extra_data.report.status }}</h3>
            <h3 class="text-xl">Reason: {{ extra_data.report.reason }}</h3>
            <h3 class="font-light">Time: {{ (new Date(extra_data.report.submit_time*1000)).toISOString().slice(0,19) }}</h3>
            <h3 class="font-light" v-if="extra_data.report.status == 'closed'">
                Time Closed: {{ (new Date(extra_data.report.closed_time*1000)).toISOString().slice(0,19) }}</h3>
            <h3 class="font-light flex items-center" 
                v-if="extra_data.user_submitted != null"
            >
                <span>Submitted By: </span>
                <UserName :user="extra_data.user_submitted"/>
            </h3>
            <h3 class="font-light flex items-center" 
                v-if="extra_data.report.closed_by"
            >
                <span>Closed By: </span>
                <UserName :user_id="extra_data.report.closed_by"/>
            </h3>
            <div class="my-4">
                {{ extra_data.report.description }}
            </div>
            <ButtonLoad class="btn btn-blue mt-8 h-10"
                    :fn="() => change_report_status('closed')"
                    :disabled="extra_data.report.status == 'closed'"
            >
                Close Report
            </ButtonLoad>
        </div>

        <div class="flex flex-col gap-y-4" v-if="extra_data.blog">
            <h2 class="font-semibold text-2xl">Blog Info</h2>
            <div>
                <h3 class="mt-4 font-semibold">Flag:</h3>
                <p class="text-2xl capitalize"> {{ extra_data.blog.flag }} </p>
            </div>
            <div>
                <h3 class="mt-4 font-semibold">Summary:</h3>
                <p class="font-light">{{ extra_data.blog.summary.slice(0, 300) }}</p>
                <router-link class="underline hover:text-accent-3-color" 
                    :to="{name: 'blog-article', params:{slug: extra_data.blog.slug}}"
                >
                    read more
                </router-link>
            </div>

            <table class="">
                <tr>
                    <th class="text-left">Word count</th> 
                    <td>{{ extra_data.blog.content.split(" ").length }}</td>
                </tr>
                <tr>
                    <th class="text-left">Status</th> 
                    <td>{{ extra_data.blog.status }}</td>
                </tr>
                <tr>
                    <th class="text-left">Flag</th> 
                    <td>{{ extra_data.blog.flag }}</td>
                </tr>
                <tr>
                    <th class="text-left">Views</th> 
                    <td>{{ extra_data.blog.views }}</td>
                </tr>
                <tr>
                    <th class="text-left">Clicks</th> 
                    <td>{{ extra_data.blog.clicks }}</td>
                </tr>
                <tr>
                    <th class="text-left">Created</th> 
                    <td>{{ new Date(extra_data.blog.create_time*1000).toLocaleString() }}</td>
                </tr>
                <tr>
                    <th class="text-left">Last updated</th> 
                    <td>{{ new Date(extra_data.blog.update_time*1000).toLocaleString() }}</td>
                </tr>
                <tr>
                    <th class="text-left">Published on</th> 
                    <td v-if="extra_data.blog.publish_time > 0">
                        {{ new Date(extra_data.blog.publish_time*1000).toLocaleString() }}
                    </td>
                    <td v-else>
                        -
                    </td>
                </tr>
            </table>

        </div>
        <div class="flex gap-x-16 w-full"
             v-if="extra_data.blog != null"
        >
            <div class="flex flex-col gap-y-4 relative"
                 v-for="user in [extra_data.author]"
            >
                <h3 class="text-lg font-medium">
                    <router-link :to="{name: 'user-info', params:{user_id: user.user_id}}">
                        <UserName :user="user" />
                    </router-link>
                </h3>
                <div class="flex gap-x-4">
                    <span class="flex items-center">
                        <FireIcon class="size-6" /> 
                        {{ user.rating.toFixed(0) }}
                    </span>
                    <span class="flex items-center">
                        <SparklesIcon class="size-6" /> 
                        {{ user.rating.toFixed(0) }}
                    </span>
                    <span class="flex items-center">
                        XP {{user.experience.toFixed(0)}}
                    </span>
                </div>
                <div class="flex gap-x-4">
                    <span class="flex items-center" v-if="user.new_rating">
                        <FireIcon class="size-6" /> 
                        {{ (user.new_rating - user.rating).toFixed(2) }}
                    </span>
                        <span class="flex items-center" v-if="user.new_coins">
                        <SparklesIcon class="size-6" /> 
                        {{ (user.new_coins - user.coins).toFixed(0) }}
                    </span>
                </div>
                <Report :object_type="'user'" :object_id="user.user_id">
                    <button class="btn btn-blue">Report User</button>
                </Report>
            </div>
        </div>

        <div v-if="extra_data.extra_data != null "
             class="flex flex-col gap-y-8"
             :set="match=extra_data.extra_data.object"
        >
        </div>

        <div v-if="extra_data.report != null && extra_data.report.status == 'open'" class="flex flex-col gap-y-4">
            <h2 class="text-2xl">Actions</h2>

            <div class="flex gap-x-2">
                <ButtonLoad v-for="flag in ['onhold', 'approved', 'featured']"
                    class="btn btn-blue h-12 max-w-96 capitalize"
                    :fn="() => set_flag(flag)"
                    :disabled="extra_data.blog.flag == flag"
                >
                    {{ flag }}
                </ButtonLoad>
            </div>
            <ButtonLoad class="btn btn-danger h-12 max-w-96"
                        :fn="delete_post"
                        :disabled="extra_data.blog == null || extra_data.blog.status == 'deleted'"
            >
                Delete Post 
            </ButtonLoad>


        </div>

        <div>
            <h2 class="text-2xl">Recent Reports</h2>
            <div class="flex justify-between gap-x-8"
                 v-for="report in extra_data.reports"
            >
                <span class="grow hover:underline hover:text-field-color cursor-pointer" 
                    @click="go_to_report(report)"
                >
                    {{ report.reason || 'No Reason'}}
                </span> 
                <span>
                    {{ report.status}}
                </span> 
                <span>
                    {{ report.submitter_id.slice(0,5)}}
                </span> 
                <span class="font-light tabular-nums">
                    {{ (new Date(report.submit_time*1000)).toISOString().slice(0,19) }}
                </span>
            </div>
        </div>

    </div>
</template>

<style>
</style>

